import { render, staticRenderFns } from "./ContentListAssociationTable.vue?vue&type=template&id=160e7a98&"
import script from "./ContentListAssociationTable.vue?vue&type=script&lang=js&"
export * from "./ContentListAssociationTable.vue?vue&type=script&lang=js&"
import style0 from "./ContentListAssociationTable.vue?vue&type=style&index=0&id=160e7a98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports